const font = {
  family: {
    default: '"IBM Plex Sans Thai", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans Thai", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    title: '"IBM Plex Sans Thai", "Noto Sans Thai", sans-serif'
  },
  size: {
    default: '16px',
    heading: {
      h1: '60px',
      h2: '48px',
      h3: '24px',
      h4: '18px',
      h5: '16px'
    },
    body: {
      large: '16px',
      medium: '14px',
      small: '12px',
      xs: '10px'
    },
    buttonText: {
      xl: '24px',
      large: '18px',
      medium: '16px',
      small: '14px',
      xs: '12px'
    },
    link: {
      large: '14px',
      medium: '12px',
      small: '10px'
    }
  },
  weight: {
    normal: '400',
    semibold: '600'
  }
};

const screen = {
  xxs: {
    max: '349.98px'
  },
  xs: {
    max: '575.98px'
  },
  sm: {
    up: '576px',
    max: '767.98px'
  },
  md: {
    up: '768px',
    max: '991.98px'
  },
  lg: {
    up: '992px',
    max: '1199.98px'
  },
  xl: {
    up: '1200px',
    max: '1399.98px'
  },
  hd: {
    up: '1400px'
  }
};

const gutter = {
  default: '1rem',
  xs: '0.25rem',
  small: '0.5rem',
  medium: '0.75rem',
  large: '1.5rem',
  xl: '2.5rem',
  section: '4rem'
};

const container = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  default: '820px',
  wallet: '470px'
};

const contentGutter = '2rem';
const headerPadding = '15px 30px';
const delay = 'all 0.2s ease-in-out';

const zindex = {
  default: '1024',
  navbar: '2048',
  bottomNav: '2148',
  sportNavbar: '1124',
  modal: '2248',
  menu: '2100',
  quickMenu: '2150'
};

const borderRadius = {
  default: '6px',
  large: '8px',
  small: '4px',
  xl: '12px',
  xxl: '14px'
};

const inputBorderRadius = borderRadius.default;
const inputheight = {
  default: '40px',
  small: '30px',
  large: '48px'
};

const initialBackground = '#f5f5f5';

const shadows = {
  shadows100: '0px 4px 4px -2px rgba(24, 39, 75, 0.08), 0px 2px 4px -2px rgba(24, 39, 75, 0.12);',
  shadows200: '0px 8px 8px -4px rgba(24, 39, 75, 0.08), 0px 4px 6px -4px rgba(24, 39, 75, 0.12);',
  shadows300: '0px 8px 16px -6px rgba(24, 39, 75, 0.08), 0px 6px 8px -6px rgba(24, 39, 75, 0.12);',
  shadows400: '0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);',
  shadows500: '0px 10px 32px -4px rgba(24, 39, 75, 0.1), 0px 6px 14px -6px rgba(24, 39, 75, 0.12);',
  shadows600: '0px 12px 42px -4px rgba(24, 39, 75, 0.12), 0px 8px 18px -6px rgba(24, 39, 75, 0.12);',
  shadows700: '0px 14px 64px -4px rgba(24, 39, 75, 0.12), 0px 8px 22px -6px rgba(24, 39, 75, 0.12);'
};

export {
  font,
  contentGutter,
  headerPadding,
  screen,
  delay,
  container,
  zindex,
  gutter,
  borderRadius,
  inputBorderRadius,
  inputheight,
  initialBackground,
  shadows
};